import { render, staticRenderFns } from "./WideMainData.vue?vue&type=template&id=01af9432&scoped=true&"
import script from "./WideMainData.vue?vue&type=script&lang=js&"
export * from "./WideMainData.vue?vue&type=script&lang=js&"
import style0 from "./WideMainData.vue?vue&type=style&index=0&id=01af9432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af9432",
  null
  
)

export default component.exports